<template>
    <v-list-item ref="infoWindow" lines="three" class="pl-0">
        <div v-if="infoLoading">
            {{ $t('loading') }}
            <v-progress-linear indeterminate color="primary" />
        </div>
        <div v-else class="align-self-start">
            <v-list-item-title :title="pointInfo.name" class="mb-1">
                <span class="text-wrap">{{ pointInfo.name }}</span>
            </v-list-item-title>
            <div v-if="pointInfo.pointName" class="text-wrap">
                <v-icon size="small">mdi-map-marker</v-icon>
                {{ `${pointInfo.pointName}, ${pointInfo.startTimes.join(', ')}` }}
            </div>
        </div>
    </v-list-item>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class ActivityMapInfoWindow extends Vue {
        @Prop() propData

        pointInfo = {}
        infoLoading = true

        async mounted() {
            this.pointInfo = this.propData
            this.infoLoading = false
        }
    }

    export default ActivityMapInfoWindow
</script>
